import React, { useEffect, useState } from "react";
import Barcode from "react-barcode";
import axios from "axios";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import "./barcodeprint.css";

const ClothStkBarcodeView = () => {
  const { Id, infoId } = useParams();
  const [rows, setRows] = useState([]);

  /* ---------------- FETCH DATA ---------------- */
  useEffect(() => {
    if (!Id) return;
    fetchBarcodes(Id, infoId);
  }, [Id, infoId]);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const fetchBarcodes = async (bId, infoId) => {
    try {
      const res = await axios.get(baseUrl, {
        params: {
          apicall: "getClothBarcodeList",
          bId,
          infoId
        }
      });

      setRows(res.data?.data ?? []);
    } catch (err) {
      console.error("Barcode fetch error", err);
      setRows([]);
    }
  };


  /* ---------------- PRINT ---------------- */
  const handlePrint = () => {
    document.getElementById("printBtn").style.display = "none";
    window.print();
  };

  /* ---------------- UI ---------------- */
  return (
    <>
      <Button
        id="printBtn"
        variant="contained"
        size="small"
        onClick={handlePrint}
        sx={{ mb: 2 }}
      >
        Print
      </Button>

      {rows.map((item) => (
        <div className="barcode" key={item.ID}>
          <h2 className="firm">{item.firmNm}</h2>
          <h6 className="cloth">{item.clothNm}</h6>

          <div className="row">
            <div>Bale: {item.bale}</div>
            <div>Rack: {item.rack}</div>
          </div>

          <div className="row">
            <div>Location: {item.locNm}</div>
            <div>Color: {item.color}</div>
          </div>
          <Barcode
            value={item.barcode}
            format="CODE128"
            width={1.4}
            height={45}
            fontSize={12}
            margin={0}
            background="#ffffff"
            lineColor="#000000"
            displayValue
          />


          <div className="row big">
            <div>Mtr:</div>
            <div>{item.mtr}</div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ClothStkBarcodeView;
